import { render, staticRenderFns } from "./ParticipantsModal.vue?vue&type=template&id=2ed82ea8&scoped=true&"
import script from "./ParticipantsModal.vue?vue&type=script&lang=js&"
export * from "./ParticipantsModal.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsModal.vue?vue&type=style&index=0&id=2ed82ea8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed82ea8",
  null
  
)

export default component.exports